import { React, useState, Fragment, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import Autocomplete from '@mui/material/Autocomplete';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import apiService from '../../services/apiServices';
import dateFormats from '../../services/dateFormats';
import validationSchema from '../../services/validationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
} from 'react-router-dom';
import { Bars } from 'react-loader-spinner';

export default function EditBranch(props) {
  //const classes = useStyles();
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [branch, setBranch] = useState([]);
  const [loader, setLoader] = useState(true);
  
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm();
  const statuses=[{id:0,name:""},{id:1,name:"aktiv"},{id:2,name:"inaktiv"}]

  let { id } = useParams();
  useEffect(() => {
    apiService()
      .query('getBranch', 'id=' + id)
      .then((response) => {
        if (response.success) {
          
          const fields = Object.keys(response.data[0]);
          fields.map((field) =>
            setValue(field, response.data[0][field])
          );
          setValue(
            'Status',
            statuses.find(function (e) {
              return e.id === response.data[0].Status;
            })
          );
          setLoader(false)
        } else {
          //alert('Error:' + response.errorMessage);
        }
      });
  }, []);

  const onSubmit = (data) => {
    data.Status=data.Status.id
  console.log(data);
  apiService()
    .put('branch', data)
    .then((response) => {
      if (response.success) {
        setToast({
          open: true,
          message: 'U ruajten me sukses!',
          variant: 'success',
        });
      } else {
        setToast({
          open: true,
          message: 'Ka ndodhur nje gabim!',
          variant: 'error',
        });
      }
    });
};
  //console.log(defaultValues);
  return (
    <div className="">
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/dashboard/editbranch"
          save={handleSubmit(onSubmit)}
        />

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Branch Data
            </Typography>
            <form>
              <Grid container spacing={3}>
                <TextField
                  sx={{ display: 'none' }}
                  variant="outlined"
                  id="id"
                  name="Id"
                  {...register('Id')}
                  value={id}
                />
                <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    placeholder="Emri i Filialit"
                    error={errors.Name}
                    control={control}
                    name="Name"
                    register={{ ...register('Name') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    placeholder="Inicialet"
                    error={errors.Name}
                    control={control}
                    name="Short"
                    register={{ ...register('Short') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={4}>
                  <SelectController
                    placeholder="Statusi"
                    error={errors.status}
                    control={control}
                    options={statuses}
                    name="Status"
                    register={{ ...register('Status') }}
                  />
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Fragment>
    </div>
  );
}
